import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Checkbox from '../Elements/Checkbox/Checkbox';
import Input from '../Elements/Input/Input';
import Select from '../Elements/Select/Select';
import Button from '../Elements/Button/Button';
import { updateEventDetails, updateEventDetailsErrors, registerParticipants } from '../../actions/environment';
import { translate } from '../../utils/string';
import s from './Event.scss';

class Event extends Component {
	constructor(props) {
		super(props);

		this.widgetID = null;
		this.reCaptchaElement = React.createRef();
	}

	componentDidMount() {
		const loadCaptcha = () => {
			if (typeof window !== 'undefined' && 'grecaptcha' in window && typeof window.grecaptcha.render === 'function' && this.reCaptchaElement.current) {
				this.widgetID = window.grecaptcha.render(this.reCaptchaElement.current);
				window.grecaptcha.reset(this.widgetID);
			} else {
				setTimeout(loadCaptcha, 200);
			}
		};

		loadCaptcha();
	}

	render() {
		const { content, currentPath, setup, eventDetails, ...props } = this.props;
		const firstContent = Array.isArray(content) && content.length > 0 ? content[0] : {};
		const participants = firstContent[`${firstContent.eventType}Participants`];
		const sectionStyle = {};
		if (firstContent.styleBackgroundColor) sectionStyle.backgroundColor = firstContent.styleBackgroundColor;
		if (firstContent.styleContentColor) sectionStyle.color = firstContent.styleContentColor;

		const participantHandler = (id, value) => {
			props.updateEventDetails(id, value);
			props.updateEventDetailsErrors(id, value);
		};

		const participantHandlerBlur = (id, value) => {
			props.updateEventDetailsErrors(id, value);
		};

		const booleanHandler = (id) => {
			props.updateEventDetails(id);
		};

		const registerParticipantsHandler = (e) => {
			e.preventDefault();
			props.registerParticipants(currentPath, participants);
		};

		if (eventDetails.serverErrors.length > 0) {
			window.grecaptcha.reset(this.widgetID);
		}

		return (
			<div className={[s.eventContainer, (sectionStyle.backgroundColor ? s.eventContainer__backgroundColor : null), (sectionStyle.backgroundColor === '#000000' ? s.eventContainer__inversed : null)].join(' ')} style={sectionStyle}>
				{
					eventDetails.eventRegistrationSucceded === true ? (
						<h1 className={s.event_form_succeeded}>
							{
								firstContent.succeeded ? translate(setup, firstContent.succeeded) : translate(setup, 'eventRegistrationSucceded')
							}
						</h1>
					) : (
						<form className={s.event} onSubmit={registerParticipantsHandler}>
							<div className={s.event_form}>
								{
									participants && Object.keys(participants).map((inputKey) => {
										const inputType = participants[inputKey];
										let hasValues = firstContent[`${inputKey}Values`];
										if (hasValues !== undefined) {
											if (typeof hasValues === 'string') {
												hasValues = hasValues.split('\n').reduce((acc, value) => {
													const values = value.trim().split(';');
													return [...acc, { key: values[0], value: values.slice(-1)[0] }];
												}, []);
												if (inputKey === 'country') hasValues.push({ key: 'Ireland', value: 'Ireland' });
												if (inputKey === 'country') hasValues = hasValues.sort((a, b) => (a.value < b.value ? -1 : 1));
											}
											hasValues = [{ key: '', value: translate(setup, 'choose') }, ...hasValues];
										}
										return (
											<div key={inputKey} className={s.event_form_row}>
												{
													hasValues !== undefined ? (
														<Select id={inputKey} options={hasValues} value={eventDetails[inputKey]} label={translate(setup, `${inputKey}Label`)} inputChange={participantHandler} inputBlur={participantHandlerBlur} isError={eventDetails.errors[inputKey]} />
													) : (
														<Input id={inputKey} type={inputType} value={eventDetails[inputKey]} label={translate(setup, `${inputKey}Label`)} inputChange={participantHandler} inputBlur={participantHandlerBlur} isError={eventDetails.errors[inputKey]} />
													)
												}
											</div>
										);
									})
								}
							</div>
							{ firstContent.allowFriends && firstContent.eventType === 'event' ? <Checkbox id="allowFriends" selected={eventDetails.allowFriends} label={translate(setup, 'eventAddFriend')} inputChange={booleanHandler} /> : null }
							{
								eventDetails.allowFriends && firstContent.eventType === 'event' ? (
									<div className={s.event_form__friend}>
										<p>{ translate(setup, 'eventFriendsDetails') }</p>
										{
											Object.keys(participants).map((inputKey) => {
												const inputType = participants[inputKey];
												return <div key={`${inputKey}Friend`} className={s.event_form_row}><Input id={`${inputKey}Friend`} type={inputType} value={eventDetails[`${inputKey}Friend`]} label={translate(setup, `${inputKey}Label`)} inputChange={participantHandler} inputBlur={participantHandlerBlur} isError={eventDetails.errors[`${inputKey}Friend`]} /></div>;
											})
										}
									</div>
								) : null
							}
							<Checkbox id="subscribeToNewsletter" selected={eventDetails.subscribeToNewsletter} label={translate(setup, 'subscribeToNewsletter')} inputChange={booleanHandler} />
							<Checkbox id="acceptTerms" selected={eventDetails.acceptTerms} innerHTML={translate(setup, 'eventAcceptTerms')} inputChange={booleanHandler} isError={eventDetails.errors.acceptTerms} />
							<div ref={this.reCaptchaElement} data-sitekey="6LcMp5cUAAAAAGFjCh70go296thom2BNYrTn8Jys" />
							{ eventDetails.eventRegistrationFailed === true && !eventDetails.errors.reCaptcha && eventDetails.serverErrors.length === 0 ? <span className={s.event_form_failed}>{ translate(setup, 'eventRegistrationFailed') }</span> : null }
							{ eventDetails.errors.reCaptcha ? <span className={s.event_form_failed}>{ translate(setup, 'reCaptchaError') }</span> : null }
							{ eventDetails.serverErrors.length > 0 ? eventDetails.serverErrors.map((error) => <span key={error} className={s.event_form_failed}>{ translate(setup, error) }</span>) : null }
							<Button text={translate(setup, 'eventSubmit')} type="submit" clickEventHandler={registerParticipantsHandler} />
						</form>
					)
				}
			</div>
		);
	}
}

const mapState = ({ environment }, { content, currentPath }) => ({ content, currentPath, setup: environment.setup, eventDetails: environment.eventDetails });

export default hot(module)(connect(mapState, { updateEventDetails, updateEventDetailsErrors, registerParticipants })(Event));
